const pagesDataConnectorEn = {
  chunkResult: {
    errors: 'Errors',
    summaryErrorMessage: 'Errors occurred on some rows. Rows with errors were not imported.',
    summaryWarningMessage: 'Processing was skipped for some rows. Please check the warnings below.',
    warnings: 'Warnings'
  },
  errorRowExport: {
    exportButton: 'Export Error Rows',
    exportStatus: 'Export Status',
    noErrorRows: 'No error rows found'
  },
  inboundAggregateDataPipeline: {
    add: {
      form: {
        dataType: {
          error: 'Data type is required',
          label: 'Data Type'
        },
        name: {
          error: 'Pipeline name is required',
          label: 'Pipeline Name',
          placeholder: 'Enter pipeline name...'
        }
      },
      pageTitle: 'Add Aggregate Pipeline',
      stepper: {
        basicInfo: 'Basic Information'
      },
      submitSuccess: 'Aggregate pipeline has been created successfully',
      title: 'Add Aggregate Pipeline'
    },
    addPipeline: 'Add aggregate pipeline',
    detail: {
      basicInfo: {
        cancel: 'Cancel',
        description: 'Manage basic settings for this aggregate pipeline.',
        edit: 'Edit',
        name: 'Pipeline Name',
        save: 'Save',
        title: 'Basic Settings'
      },
      chunks: {
        breadcrumb: {
          chunks: 'Chunks',
          result: 'Chunk Result',
          tasks: 'Execution History'
        },
        pageTitle: 'Chunks',
        result: {
          unit: 'records'
        },
        resultPageTitle: 'Chunk Result'
      },
      executionPlanSettings: {
        cancel: 'Cancel',
        description: 'Execution plan configuration for this aggregate pipeline.',
        edit: 'Edit',
        operationMode: 'Operation Mode',
        save: 'Save',
        title: 'Execution Plan',
        triggerMode: 'Trigger Mode',
        updateSuccess: 'Execution plan has been updated'
      },
      prioritySetting: {
        addPipeline: 'Add Pipeline',
        cancel: 'Cancel',
        dataType: 'Data Type',
        description: 'Configure the priority of pipelines and matching key.',
        edit: 'Edit',
        matchingKeyCode: 'Matching Key',
        noPipelines: 'No pipelines configured.',
        pipelines: 'Pipelines',
        save: 'Save',
        title: 'Priority Setting',
        updateSuccess: 'Priority setting has been updated'
      },
      scheduleSettings: {
        title: 'Schedule Settings'
      },
      tabs: {
        basicInfo: 'Basic Settings',
        executionPlan: 'Execution Plan',
        prioritySetting: 'Priority Setting',
        tasks: 'Execution History'
      },
      tasks: {
        execute: 'Execute',
        executeConfirm: {
          description: 'Are you sure you want to execute this aggregate pipeline?',
          title: 'Execute Aggregate Pipeline'
        },
        executeDisabledPaused: 'Cannot execute because operation mode is paused',
        executeDisabledScheduled: 'Cannot execute manually because scheduled execution is configured',
        executeSuccess: 'Execution has been started',
        hasFailedPipelineTask: 'Some pipeline tasks have failed',
        loading: 'Loading...',
        noTasks: 'No execution history found.',
        pageTitle: 'Execution History',
        subTable: {
          completedAt: 'Completed At',
          latestEvent: 'Latest Event',
          pipelineName: 'Pipeline Name',
          priority: 'Priority',
          startedAt: 'Started At'
        }
      },
      updateSuccess: 'Basic settings have been updated'
    },
    pageTitle: 'Aggregate Pipeline'
  },
  inboundDataPipeline: {
    add: {
      form: {
        appIntegrationId: {
          error: 'Integrated app is required',
          label: 'Integrated App'
        },
        dataType: {
          error: 'Data type is required',
          label: 'Data Type'
        },
        name: {
          error: 'Pipeline name is required',
          label: 'Pipeline Name',
          placeholder: 'Enter pipeline name...'
        },
        sourceType: {
          error: 'Source type is required',
          label: 'Source Type'
        },
        storageSourceType: {
          error: 'Integrated storage is required',
          label: 'Integrated Storage'
        }
      },
      pageTitle: 'Add Pipeline',
      stepper: {
        basicInfo: 'Basic Information'
      },
      submitSuccess: 'Pipeline has been created successfully',
      title: 'Add pipeline'
    },
    addPipeline: 'Add data pipeline',
    detail: {
      basicSettings: {
        appIntegration: 'Integrated App',
        cancel: 'Cancel',
        dataType: {
          label: 'Data Type'
        },
        description: 'Manage basic settings for this data pipeline.',
        edit: 'Edit',
        name: 'Pipeline Name',
        save: 'Save',
        sourceType: {
          label: 'Source Type'
        },
        storageSourceType: {
          label: 'Integrated Storage'
        },
        title: 'Basic Settings'
      },
      dataLinkSettings: {
        addTarget: 'Add destination',
        cancel: 'Cancel',
        classificationSettings: {
          addRow: 'Add rule',
          addSource: 'Add source field',
          cancel: 'Cancel',
          missHintCrossSource: 'Unmatched values fall back to the normal mapping.',
          missHintSameSource: 'Unmatched values are imported as-is, without translation.',
          moveDown: 'Move down',
          moveUp: 'Move up',
          noRules: 'No value translations configured.',
          priorityHint: 'You can add multiple source fields in priority order (top is highest). When more than one matches, the topmost value is used.',
          priorityLabel: 'Priority {{rank}}',
          removeSource: 'Remove',
          save: 'Save',
          selectSourceField: 'Select source field',
          selectTargetValue: 'Select translated value',
          sourceField: 'Source field',
          sourceFieldHint: 'A value mapping references a single source column per target (to keep runtime precedence unambiguous)',
          sourceValuePlaceholder: 'Source value',
          targetAttribute: 'Target attribute',
          targetValuePlaceholder: 'Target value',
          title: 'Value Translation Settings',
          validation: {
            duplicate: 'Duplicate rule',
            duplicateSourceField: 'The same source field is used in more than one priority',
            incompleteRule: 'Both the source value and the converted value are required'
          }
        },
        clearAllConfirm: {
          confirmOk: 'Remove all',
          description: 'All mappings will be removed. Do you want to proceed?',
          title: 'Remove all mappings'
        },
        constantMapping: {
          addRow: 'Add constant row',
          sectionLabel: 'Constant values (no source field)',
          valuePlaceholder: 'Constant value',
          valueRequired: 'A constant value is required'
        },
        defaultValueKind: {
          fixed: 'Fixed value',
          today: 'Import date'
        },
        defaultValueLabel: 'Default value',
        detectConfirm: {
          descriptionInitial: 'This will detect source fields from the data source.',
          descriptionPrefix: 'Re-detect source fields based on the latest data.',
          executeReDetect: 'I understand, re-detect',
          title: 'Detect Source Fields',
          titleReDetect: 'Re-detect source fields?',
          warningBody: 'Any source fields no longer present in the detection result will have their associated mappings automatically removed. This action cannot be undone.',
          warningTitle: 'Existing mappings may be automatically removed'
        },
        detectSourceFields: 'Detect Source Fields',
        detectSuccess: 'Source field detection has started. Results will be reflected once complete.',
        domainTypeSettings: {
          addRow: 'Add rule',
          cancel: 'Cancel',
          clearAllConfirm: {
            confirmOk: 'Remove all',
            description: {
              DEVICE: 'All organization-specific routing rules will be removed. The system will fall back to keyword-based inference. Do you want to proceed?',
              PEOPLE: 'All organization-specific routing rules will be removed. After that, unmatched source values are imported as the "Pipeline Default" type if one exists, or become import errors if not. Do you want to proceed?'
            },
            title: 'Remove all routing rules'
          },
          defaultRowBadge: '(Default)',
          defaultRowNoSourceField: 'None (default row)',
          defaultRowSection: {
            addButton: 'Add default row',
            description: 'The default type applied to source values not matched by any routing rule.',
            removeButton: 'Remove default row',
            title: 'Pipeline Default'
          },
          description: {
            DEVICE: 'Route source values to device type categories (MOBILE / COMPUTER / SERVER / MONITOR / OTHER).',
            PEOPLE: 'Route source values to member type categories (Employee / Contractor / Board Member / Collaborator).'
          },
          deviceDomainType: {
            COMPUTER: 'Computer',
            MOBILE: 'Mobile',
            MONITOR: 'Monitor',
            OTHER: 'Other',
            SERVER: 'Server'
          },
          domainTypeFilter: {
            allExcludedDescription: 'This intentionally pauses member imports. No member records will be imported until a type is enabled again.',
            allExcludedTitle: 'All member types are excluded',
            description: 'Select which classified member types to import.',
            discardChanges: 'Discard changes',
            excluded: 'Excluded',
            included: 'Included',
            saveSuccess: 'Import targets saved',
            title: 'Import Target Settings',
            unsavedChanges: 'Unsaved changes'
          },
          edit: 'Edit',
          fallbackHint: {
            DEVICE: 'Unmatched values fall back to keyword-based inference of the device type (e.g. OS / model / manufacturer).',
            PEOPLE: 'Source values that do not match any routing rule are imported as the "Pipeline Default" type if one is set, or become import errors if not. Add a "Pipeline Default" to put everyone in the same type, or add routing rules to split by type.'
          },
          noRules: {
            DEVICE: 'No routing rules configured. Default keyword inference will apply.',
            PEOPLE: 'No routing rules configured. Source values are imported as the type configured in the "Pipeline Default" (if there is no "Pipeline Default", import fails).'
          },
          save: 'Save',
          saveSuccess: 'Routing rules saved',
          selectDeviceType: 'Select device type',
          selectPeopleType: 'Select member type',
          selectSourceField: 'Select source field',
          sourceField: 'Source field',
          sourceValue: 'Source value',
          sourceValuePlaceholder: 'Source value',
          targetType: 'Target type',
          title: {
            DEVICE: 'Device Type Settings',
            PEOPLE: 'Member Type Classification Settings'
          },
          trimNotice: 'Stored as: {{value}}',
          validation: {
            duplicate: 'Duplicate (source field, source value)'
          }
        },
        edit: 'Edit',
        fallbackSourceFieldLabel: 'Fallback source',
        fallbackSourceFieldTooltip: 'Vendor-fixed fallback source field. Editing is not supported.',
        isRequired: {
          columnHeader: 'Required',
          description: 'When ON, records with an empty value after mapping will fail to import (error row).',
          disabledHint: 'This row is disabled, so the required check does not apply.',
          label: 'Required',
          onBadge: 'Required',
          tooltip: 'When ON, records with an empty value after mapping will fail to import (error row).',
          warning: {
            defaultValueConflict: 'A default value is set, so an empty value will not occur. This may conflict with the intent of marking it as required.'
          }
        },
        noMappings: 'No mappings configured.',
        noSourceFields: "No source fields detected. Click the 'Detect Source Fields' button.",
        peopleDomainType: {
          BOARD_MEMBER: 'Board Member',
          COLLABORATOR: 'Collaborator',
          CONTRACTOR: 'Contractor',
          EMPLOYEE: 'Employee'
        },
        peopleDomainTypeDescription: {
          BOARD_MEMBER: 'Mappings applied to board member records.',
          COLLABORATOR: 'Mappings applied to collaborator records.',
          CONTRACTOR: 'Mappings applied to contractor records.',
          EMPLOYEE: 'Mappings applied to employee records.'
        },
        removeTarget: 'Remove destination',
        requiresSourceFields: 'Detect source fields above first. You can edit this setting after detection completes.',
        save: 'Save',
        saveSuccess: 'Mappings saved',
        selectDestination: 'Select destination',
        sourceDetection: {
          descriptionDetected: '{{count}} source field(s) detected. Configure the sections below as needed.',
          descriptionInitial: 'Connect to the data source to detect source fields. Detection may take several minutes, so after starting it, wait a moment and refresh this page to confirm the results. After detection completes, configure the sections below as needed.',
          detecting: 'Detecting...',
          timeWarning: 'Detection may take a few minutes. Leave this page for a while, then come back and refresh to check results. When complete, they will appear on this screen.',
          title: 'Source Field Detection'
        },
        split: {
          addCandidate: 'Add OR candidate',
          addGroup: 'Add delimiter condition',
          columnHeader: 'Part',
          customDelimiterPlaceholder: 'Enter delimiter',
          dialogDescription: 'Split the value of {{sourceField}} into multiple parts by delimiters.',
          dialogTitle: 'Split settings',
          editButtonOff: 'Split settings',
          editorTitle: 'Delimiter conditions (split left to right)',
          emptyGroupError: 'Add at least one OR candidate',
          emptyPart: '(empty)',
          groupLabel: 'Delimiter {{index}}',
          memberTypeSharedNote: 'The delimiter definition is shared for this source field across all member types (the destination of each part can be set per member type).',
          minMappingsRequired: 'When splitting, assign a destination to at least two of the whole value / parts',
          noGroupsHint: 'No delimiter conditions. The whole value becomes a single part.',
          partLabel: 'Part {{index}}',
          partMappingTitle: 'Destination for each part',
          previewTitle: 'Split preview',
          removeCandidate: 'Remove OR candidate',
          removeGroup: 'Remove delimiter condition',
          samplePlaceholder: 'Enter a sample value',
          unset: 'Remove split',
          wholeValue: 'Whole value'
        },
        title: 'Mapping Settings',
        uniqueKeySettings: {
          cancel: 'Cancel',
          description: 'Choose the key attribute used to match external system records with DRESS CODE records.',
          edit: 'Edit',
          noCandidates: 'No candidates available.',
          noSelection: 'Not selected',
          save: 'Save',
          saveSuccess: 'Unique key settings saved',
          selectPlaceholder: 'Select a key attribute',
          title: 'Unique Key Settings'
        },
        unmappedSourceFields: 'Unmapped (detected only)',
        validation: {
          duplicateTarget: 'Too many sources mapped to this destination',
          splitTargetRequired: 'When a split is configured, select a destination for each row',
          targetRequired: 'Select a destination'
        }
      },
      executionPlanSettings: {
        cancel: 'Cancel',
        description: 'Execution plan configuration for this data pipeline.',
        edit: 'Edit',
        ingestionMode: 'Ingestion Mode',
        operationMode: 'Operation Mode',
        save: 'Save',
        title: 'Execution Plan',
        triggerMode: 'Trigger Mode',
        updateSuccess: 'Execution plan has been updated'
      },
      executionResults: {
        execute: 'Execute',
        executeConfirm: {
          description: 'Are you sure you want to execute this pipeline?',
          title: 'Execute Pipeline'
        },
        executeDisabledPaused: 'Cannot execute because operation mode is paused',
        executeDisabledScheduled: 'Cannot execute manually because scheduled execution is configured',
        executeSuccess: 'Execution has been started',
        pageTitle: 'Execution Results',
        uploadCsv: 'Upload CSV',
        uploadDialog: {
          cancel: 'Cancel',
          description: 'Select a CSV file to upload to this pipeline.',
          submit: 'Upload',
          title: 'Upload CSV File',
          uploading: 'Uploading...'
        },
        uploadFailed: 'Failed to upload CSV',
        uploadSuccess: 'CSV has been uploaded'
      },
      header: {
        connection: 'Connection'
      },
      scheduleSettings: {
        title: 'Schedule Settings'
      },
      tabs: {
        basicSettings: 'Basic Settings',
        dataLinkSettings: 'Data Link Settings',
        executionPlan: 'Execution Plan',
        executionResults: 'Execution Results'
      },
      taskDetail: {
        breadcrumb: {
          chunks: 'Chunks',
          result: 'Chunk Result',
          tasks: 'Tasks'
        },
        chunkResult: {
          unit: 'records'
        },
        chunkResultPageTitle: 'Chunk Result',
        pageTitle: 'Task Details',
        retry: 'Retry',
        retryConfirm: {
          description: 'The retry will be performed using the same data as this task.',
          title: 'Retry Task'
        },
        retrySuccess: 'Retry has been started',
        toolbar: {
          chunks: 'Chunks',
          executionResults: 'Execution Results'
        }
      },
      updateSuccess: 'Basic information has been updated'
    },
    pageTitle: 'Data Pipeline',
    sourceTypeFilter: {
      all: 'All',
      api: 'API/Webhook',
      storage: 'File upload'
    }
  },
  outboundDataPipeline: {
    addPipeline: 'Add output pipeline',
    breadcrumb: 'Outbound pipeline',
    cancel: 'Cancel',
    dataType: 'Data type',
    dataTypeOption: {
      PEOPLE: 'People'
    },
    detail: {
      basicSettings: {
        description: 'Manage the display name and data type of the outbound pipeline.',
        title: 'Basic settings'
      },
      dataLinkSettings: {
        mapping: {
          addColumn: 'Add column',
          addConstantColumn: 'Add constant column',
          constantSource: 'Constant value (no source)',
          destinationPlaceholder: 'Destination',
          emptyRows: 'No output columns. Create one from "Add column".',
          fallbackSuffix: ' (fallback: {{name}})',
          noMappings: 'No mappings configured.',
          required: 'Required',
          requiredTooltip: 'When on, rows whose value becomes empty after transformation are excluded from the output CSV and recorded as errors in errors.csv.',
          sourcePlaceholder: 'Select a source field',
          title: 'Mapping settings'
        },
        peopleDomainType: {
          BOARD_MEMBER: 'Board member',
          COLLABORATOR: 'External collaborator',
          CONTRACTOR: 'Contractor',
          EMPLOYEE: 'Employee'
        },
        peopleDomainTypeDescription: {
          BOARD_MEMBER: 'Mapping settings for board members.',
          COLLABORATOR: 'Mapping settings for external collaborators.',
          CONTRACTOR: 'Mapping settings for contractors.',
          EMPLOYEE: 'Mapping settings for employees.'
        },
        valueMapping: {
          addRow: 'Add rule',
          cancel: 'Cancel',
          configuredCount: '{{configured}} configured',
          csvImport: 'Import from CSV',
          csvImportDescription: 'Upload a CSV whose first column is the source value and second column is the transformed value.',
          csvImportSubmit: 'Import',
          csvImportTitle: 'Import value mapping from CSV',
          description: 'Configure the value mapping rules for the "{{column}}" column.',
          descriptionBound: 'Configure the value mapping rules for the "{{column}}" column ({{ref}}).',
          duplicateSource: 'Each source value can be mapped only once. Please remove the duplicates.',
          freeHint: 'Enter pairs of input value (before) and output value (after).',
          loadingCandidates: 'Loading candidates...',
          noEntries: 'No rules yet. Add one with "Add rule".',
          ref: {
            BloodRhFactor: 'Blood type (Rh)',
            BloodType: 'Blood type (ABO)',
            Sex: 'Sex'
          },
          save: 'Save',
          sourcePlaceholder: 'Value before',
          sourceSelectPlaceholder: 'Select source value',
          targetPlaceholder: 'Value after',
          title: 'Value Translation Settings',
          unset: 'Clear value mapping'
        }
      },
      executionPlanSettings: {
        ingestionMode: {
          FULL: 'Full'
        },
        operationMode: {
          PAUSED: 'Paused',
          RUNNING: 'Running'
        },
        outputMode: 'Output Mode',
        triggerMode: {
          MANUAL: 'Manual',
          SCHEDULE: 'Schedule'
        }
      },
      executionResults: {
        download: 'Download',
        execute: 'Execute',
        executeDialog: {
          baseDate: 'Base date',
          baseDatePlaceholder: 'Select a base date',
          confirm: 'Execute',
          description: 'Outputs the data as of the base date.',
          title: 'Execute output'
        },
        executeDisabledPaused: 'Cannot execute because operation mode is paused',
        executeDisabledScheduled: 'Cannot execute manually because scheduled execution is configured',
        executeStartedDescription: 'This may take a few minutes. Results will appear in the execution results list once finished (the screen does not update automatically).',
        executeStartedTitle: 'Execution started',
        noArtifacts: 'No downloadable artifacts.'
      },
      tabs: {
        basicSettings: 'Basic settings',
        dataLinkSettings: 'Data link settings',
        executionPlan: 'Execution plan',
        executionResults: 'Execution results'
      }
    },
    edit: 'Edit',
    loading: 'Loading...',
    name: 'Pipeline Name',
    namePlaceholder: 'Outbound pipeline name',
    save: 'Save'
  },
  productHeader: {
    pageTitle: 'Data Connector'
  },
  tabs: {
    inbound: 'Inbound (IN)',
    inboundAggregateDataPipelines: 'Aggregate Data Pipelines',
    outbound: 'Outbound (OUT)',
    pipelines: 'Pipelines'
  }
};
export default pagesDataConnectorEn;